import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import FourColumnLayout from '../../containers/four-column-layout';
//import OneColumnLayout from '../../blocks/one-column-layout';
//import TwoColumnLayout from '../../blocks/two-column-layout';
//import ThreeColumnLayout from '../../blocks/three-column-layout';
import Photogallery from '../../blocks/photogallery';
import Presentation from '../../blocks/presentation';
import Slideshow from '../../blocks/slideshow';
import Slidegallery from '../../blocks/slidegallery';
import Promo from '../../containers/promo';
import Video from '../../blocks/video';
import Html from '../../containers/html';
import Wysiwyg from '../../containers/wysiwyg';

const FourColumnLayoutBlock = props => <FourColumnLayout {...props} />;
FourColumnLayoutBlock.displayName = 'FourColumnLayout';

export default withDynamicComponents({
  componentWhitelist: [
    //OneColumnLayout,
    //TwoColumnLayout,
    //ThreeColumnLayout,
    Photogallery,
    Presentation,
    Slideshow,
    Slidegallery,
    Promo,
    Wysiwyg,
    Video,
    Html,
  ],
  mapInputToOutput: [
    ['firstContent', 'firstContent'],
    ['secondContent', 'secondContent'],
    ['thirdContent', 'thirdContent'],
    ['fourthContent', 'fourthContent'],
  ],
})(FourColumnLayoutBlock);



// WEBPACK FOOTER //
// ./src/blocks/four-column-layout/index.jsx